import { render, staticRenderFns } from "./MyTasksPage.vue?vue&type=template&id=dde70250&scoped=true&"
import script from "./MyTasksPage.vue?vue&type=script&lang=js&"
export * from "./MyTasksPage.vue?vue&type=script&lang=js&"
import style0 from "./MyTasksPage.vue?vue&type=style&index=0&id=dde70250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde70250",
  null
  
)

export default component.exports